<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2024 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<ng-container *ngIf="getDirection() === 'inline'">
    <div class="d-flex">
        <ng-container
                *ngIf="selectedValues && selectedValues.length > 0 && selectedValues.length <= this.getBreakpoint()">
            <ng-container *ngFor="let option of selectedValues; let i = index;">
                <div *ngIf="i > 0" class="pr-1 align-content-center">,</div>
                <div class="d-flex align-items-center">
                    <div class="">
                        <a [routerLink]="option.link">
                            {{ option.value }}
                        </a>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="selectedValues && selectedValues.length > this.getBreakpoint()">
            <ng-container *ngFor="let option of selectedValues | slice:0:this.getBreakpoint(); let i = index">
                <div *ngIf="i > 0" class="pr-1 align-content-center">,</div>
                <div class="d-flex align-items-center">
                    <div class="">
                        <a [routerLink]="option.link">
                            {{ option.value }}
                        </a>
                    </div>
                </div>
            </ng-container>

            <ng-template #popContent>
                <ul class="mb-1">
                    <div class="container container-popover scrollbar-thin"
                         *ngFor="let selected of getExtraOptions();">
                        <li>
                            <a [routerLink]="selected.link">
                                {{ selected.value }}
                            </a>
                        </li>
                    </div>
                </ul>
            </ng-template>
            <a class="clickable" [ngbPopover]="popContent">
                <div class="pr-1 align-content-center">, +{{ selectedValues.length - this.getBreakpoint() }}
                    <scrm-label [labelKey]="'LBL_MORE'"></scrm-label>
                </div>
            </a>
        </ng-container>
    </div>
</ng-container>
<ng-container *ngIf="getDirection() === 'vertical'">
    <ng-container *ngIf="selectedValues && selectedValues.length > 0 && selectedValues.length <= this.getBreakpoint()">
        <ul class="mb-1">
            <ng-container *ngFor="let option of selectedValues; let i = index;">
                <li>
                    <a [routerLink]="option.link">
                        {{ option.value }}
                    </a>
                </li>
            </ng-container>
        </ul>
    </ng-container>
    <ng-container *ngIf="selectedValues && selectedValues.length > this.getBreakpoint()">
        <ul class="mb-1">
            <ng-container *ngFor="let option of selectedValues | slice:0:this.getBreakpoint(); let i = index">
                <li>
                    <a [routerLink]="option.link">
                        {{ option.value }}
                    </a>
                </li>
            </ng-container>
        </ul>
        <ng-template #popContent>
            <ul class="mb-1">
                <div class="container container-popover scrollbar-thin"
                     *ngFor="let selected of getExtraOptions();">
                    <li>
                        <a [routerLink]="selected.link">
                            {{ selected.value }}
                        </a>
                    </li>
                </div>
            </ul>
        </ng-template>
        <a class="clickable" [ngbPopover]="popContent" [placement]="'bottom-left'">
            <div class="pr-1 align-content-center">+{{ selectedValues.length - this.getBreakpoint() }}
                <scrm-label [labelKey]="'LBL_MORE'"></scrm-label>
            </div>
        </a>
    </ng-container>
</ng-container>
